/** Summary of what changed between two versions of the pricing Sheet (Actualizar parámetros). */

/** Values the Sheet holds as a share of 1: shown as a percentage. */
const SHARE_LABEL = /margen|piso|activación|tenencia|probabilidad|descuento|comisión/i;

/**
 * A Sheet value as read: shares as %, the rest with up to 4 decimals and
 * Chilean separators; "—" when absent.
 *
 * @param {number|string|null} value
 * @param {string} label - What the value is; tells whether it is a share.
 */
export function changeValueText(value, label) {
  if (value === null || value === undefined) return '—';
  if (typeof value !== 'number') return value;
  if (SHARE_LABEL.test(label)) return `${(value * 100).toLocaleString('es-CL', { maximumFractionDigits: 2 })}%`;
  return value.toLocaleString('es-CL', { maximumFractionDigits: 4 });
}

/** Label for the changes whose Sheet row has no note. */
export const NO_REASON = 'Sin nota en el Sheet';

/**
 * The changed values grouped by the note of their Sheet row, in Sheet order,
 * with how many values each note covers; the ones without a note go last.
 * A fallback for when nobody explained the version in the "Cambios" tab.
 *
 * @param {Array<{reason: string|null}>} changes
 * @returns {Array<{reason: string, count: number}>}
 */
export function noteReasons(changes) {
  const counts = new Map();
  for (const change of changes) {
    const reason = change.reason || NO_REASON;
    counts.set(reason, (counts.get(reason) ?? 0) + 1);
  }
  return [...counts.entries()]
    .sort(([a], [b]) => (a === NO_REASON) - (b === NO_REASON))
    .map(([reason, count]) => ({ reason, count }));
}
